import { createTermsTagsManager } from '../../utils/createTermsTagsManager';
import { EFloorTypes } from '../../../../api-models/common/json_query';

const FLOOR_TYPES_MAP_VALUE_TO_LABEL: Record<EFloorTypes, string> = {
  [EFloorTypes.OnlyFirstFloor]: 'Только первый',
  [EFloorTypes.NotBasement]: 'Не цоколь, не подвал',
};

export const floorTypesTagsManager = createTermsTagsManager({
  jsonQueryKey: 'floor_types',
  mapValueToLabel: FLOOR_TYPES_MAP_VALUE_TO_LABEL,
  id: 'floorTypes',
});
